import moment from "moment";
export const baseMixin = {
    data: function () {
        return {
            message: 'hello',
            user: {
                name:"test name"
            }
        }
    },
    methods: {
        serialize(obj) {
            let str = [];
            for (let p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        // use with only status 422
        showErrorMessage(errors, formName = undefined) {
            this.formShowErrorMessage(errors, formName)
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex%2 === 1) {
                return 'success-row';
            }
            return '';
        },
        convertTimeToUTC(time, format) {
            return time ? format ? moment(time).utc().format(format) : moment(time).utc().format('yyyy-MM-DD HH:mm:ss') : null
        },
        convertTimeToLocal(time, format) {
            return time ? format ? moment.utc(time).local().format(format) : moment.utc(time).local().format('yyyy-MM-DD HH:mm:ss') : null
        },
        formShowErrorMessage(errors, formName) {
            const fieldError = Object.keys(errors)
            this.$refs[formName].$children.forEach((children) => {
                if (children.prop === 'parent') {
                    if (fieldError.includes(children.prop)) {
                        children.validateState = 'error'
                        children.validateMessage = errors[children.prop][0]
                    }
                    children.$children.forEach((subChildren) => {
                        subChildren.$children.forEach((tinyChildren) => {
                            if (!fieldError.includes(tinyChildren.prop)) {
                                return
                            }
                            tinyChildren.validateState = 'error'
                            tinyChildren.validateMessage = errors[tinyChildren.prop][0]
                        })
                    })
                }
                if (!fieldError.includes(children.prop)) {
                    if (fieldError.includes('data')) {
                        this.notifyError(errors.data)
                    }
                    return
                }
                children.validateState = 'error'
                children.validateMessage = errors[children.prop][0]
            })
        },
        formatDateTime(datetime) {
            return datetime ? moment(datetime).format('yyyy年MM月DD日 HH:mm:ss') : ''
        },
        formatDate(date) {
            return date ? moment(date).format('yyyy年MM月DD日') : ''
        },
        formatMoney(money) {
            money = (typeof(parseInt(money)) == 'number')?parseInt(money):0;
            let val = (money/1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        formatMinute(number) {
            number = (typeof(parseInt(number)) == 'number')?parseInt(number):0;
            let val = (number/60).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        turnOffErrorMessage(formName) {
            this.$refs[formName].$children.forEach((children) => {
                children.$children.forEach((subChildren) => {
                    if (subChildren.validateState) {
                        subChildren.validateState = ''
                        subChildren.validateMessage = ''
                    }
                    subChildren.$children.forEach((tinyChildren) => {
                        if (tinyChildren.validateState) {
                            tinyChildren.validateState = ''
                            tinyChildren.validateMessage = ''
                        }
                    })
                })
                if (children.validateState) {
                    children.validateState = ''
                    children.validateMessage = ''
                }
            })
        },
        checkErrorMessage(formName) {
            let check = false
            this.$refs[formName].$children.forEach((children) => {
                children.$children.forEach((subChildren) => {
                    if (subChildren.validateState) {
                        if (subChildren.validateMessage) {
                            check = true
                        }
                    }
                    subChildren.$children.forEach((tinyChildren) => {
                        if (tinyChildren.validateState) {
                            if (tinyChildren.validateMessage) {
                                check = true
                            }
                        }
                    })
                })
            })
            return check
        },
        turnOffErrorMessageField(formName, prop) {
            this.$refs[formName].$children.forEach((children) => {
                if (children.prop === 'parent') {
                    children.$children.forEach((subChildren) => {
                        subChildren.$children.forEach((tinyChildren) => {
                            if (tinyChildren.prop === prop) {
                                tinyChildren.validateState = ''
                                tinyChildren.validateMessage = ''
                            }
                        })
                    })
                }
                if (children.prop === prop) {
                    children.validateState = ''
                    children.validateMessage = ''
                }
            })
        },
        notifyError(message) {
            this.$notify.error({
                title: 'Error',
                message: message
            });
        },
        notifySuccess(message) {
            this.$notify({
                title: 'Success',
                message: message,
                type: 'success'
            });
        },
    }
};
